// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"206":"131c3c38","440":"3276f6cb"}[chunkId] + ".chunk.css";
};